import { Loader } from '@mantine/core';

type LoadingSpinnerProps = {
  variant?: 'page' | 'inline';
  size?: number;
  color?: string;
  style?: React.CSSProperties;
};

export const LoadingSpinner = ({
  variant = 'page',
  size = 24,
  color = '#6b46e3',
  style,
}: LoadingSpinnerProps) => {
  if (variant === 'page') {
    return (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <span
          style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: '#0f172a',
            letterSpacing: '0.04em',
          }}
        >
          DABSI
        </span>
        <Loader size={28} color="#6b46e3" type="dots" />
      </div>
    );
  }

  return <Loader size={size} color={color} style={style} />;
};
